
<template>
  <page :manualInit="claimRegister.init" :manualErr="claimRegister.initErr" @reload="doInit">
    <template slot="pageAction">
      <claim-helper-menu></claim-helper-menu>
      <div class="actionBlock" v-if="!isMatchRouteExact('claimRegister')">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              More Links...
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="sideMenuClick"></side-function-menu>
        </v-menu>
      </div>
      <div class="actionBlock">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" @click="lifeCycle = !lifeCycle" v-on="on" id="OverviewBtn">
              Overview
              <v-icon right>mdi-file-document-box</v-icon>
            </v-btn>
          </template>
          <span>Overview</span>
        </v-tooltip>
      </div>
    </template>
    <transition name="slide-x-transition" mode="out-in">
      <router-view :toggleQuery="toggleQuery"></router-view>
    </transition>
    <v-navigation-drawer temporary clipped fixed right hide-overlay v-model="lifeCycle" width="400">
      <claim-life-cycle @statusChange="editStatusChange" :query="query"></claim-life-cycle>
    </v-navigation-drawer>
    <v-dialog v-model="statusChange" persistent width="800px">
      <claim-status-dialog @close="statusChange = false"></claim-status-dialog>
    </v-dialog>
    <v-dialog v-model="saveError" width="800px">
      <save-error-dialog @close="saveError = false"></save-error-dialog>
    </v-dialog>
    <div v-if="renderComments">
      <v-container fluid grid-list-sm>
        <v-layout row wrap>
          <v-flex lg12 xs12 order-lg1 order-xs2>
            <comments></comments>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <v-dialog v-model="$store.state.claims.claimDetail.saving" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Saving Claim. Please wait.
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="getSideControlMenu('text').show" width="1000px" persistent>
      <Claim-Text :load="getSideControlMenu('text').show" @close="getSideControlMenu('text').show = false"></Claim-Text>
    </v-dialog>
    <v-dialog v-model="getSideControlMenu('reinsurance').show" width="1000px" persistent>
      <Claim-Reinsurance :load="getSideControlMenu('reinsurance').show" @close="getSideControlMenu('reinsurance').show = false"></Claim-Reinsurance>
    </v-dialog>
    <v-dialog v-model="getSideControlMenu('clmrircvy').show" width="1000px" persistent>
      <Claim-R-I-Recovery :load="getSideControlMenu('clmrircvy').show" @close="getSideControlMenu('clmrircvy').show = false"></Claim-R-I-Recovery>
    </v-dialog>
    <v-dialog v-model="getSideControlMenu('xolrcvy').show" width="1000px" persistent>
      <X-O-L-Recovery :load="getSideControlMenu('xolrcvy').show" @close="getSideControlMenu('xolrcvy').show = false"></X-O-L-Recovery>
    </v-dialog>
    <v-dialog v-model="getSideControlMenu('xolWrksht').show" width="1250px" persistent>
      <X-O-L-Worksheet :load="getSideControlMenu('xolWrksht').show" @close="getSideControlMenu('xolWrksht').show = false"></X-O-L-Worksheet>
    </v-dialog>
    <v-dialog v-model="getSideControlMenu('statistics').show" width="1000px" persistent>
      <Claim-Statistics :load="getSideControlMenu('statistics').show" @close="getSideControlMenu('statistics').show = false"></Claim-Statistics>
    </v-dialog>
    <v-dialog v-model="getSideControlMenu('clmattachfile').show" width="1000px" persistent>
      <Claim-Attach-File
        :load="getSideControlMenu('clmattachfile').show"
        @close="getSideControlMenu('clmattachfile').show = false"
      ></Claim-Attach-File>
    </v-dialog>
    <v-dialog v-model="getSideControlMenu('clmstatus').show" width="1000px" persistent>
      <Claim-Status :load="getSideControlMenu('clmstatus').show" @close="getSideControlMenu('clmstatus').show = false"></Claim-Status>
    </v-dialog>
    <v-dialog v-model="getSideControlMenu('clmres').show" width="1300px" persistent>
      <Claim-Reserve :load="getSideControlMenu('clmres').show" @close="getSideControlMenu('clmres').show = false"></Claim-Reserve>
    </v-dialog>
    <v-dialog v-model="getSideControlMenu('clmpayt').show" width="1750px" persistent>
      <Claim-Payment :load="getSideControlMenu('clmpayt').show" @close="getSideControlMenu('clmpayt').show = false"></Claim-Payment>
    </v-dialog>
    <v-dialog v-model="getSideControlMenu('clmByLossDate').show" width="1000px" persistent>
      <Claim-By-Loss-Date
        :load="getSideControlMenu('clmByLossDate').show"
        @close="getSideControlMenu('clmByLossDate').show = false"
      ></Claim-By-Loss-Date>
    </v-dialog>
    <v-dialog v-model="getSideControlMenu('clmAcct').show" width="1000px" persistent>
      <Claim-Account :load="getSideControlMenu('clmAcct').show" @close="getSideControlMenu('clmAcct').show = false"></Claim-Account>
    </v-dialog>
    <v-dialog v-model="getSideControlMenu('clmMtrDrvr').show" width="1000px" persistent>
      <Claim-Motor-Driver :load="getSideControlMenu('clmMtrDrvr').show" @close="getSideControlMenu('clmMtrDrvr').show = false"></Claim-Motor-Driver>
    </v-dialog>
    <v-dialog v-model="getSideControlMenu('clmDoc').show" width="1250px" persistent>
      <Clm-Document
        :load="getSideControlMenu('clmDoc').show"
        @close="getSideControlMenu('clmDoc').show = false"
        :refresh="getSideControlMenu('clmDoc').show"
      ></Clm-Document>
    </v-dialog>
    <v-dialog v-model="getSideControlMenu('clmHistory').show" width="1250px" persistent>
      <Claim-History
        :load="getSideControlMenu('clmHistory').show"
        @close="getSideControlMenu('clmHistory').show = false"
        :refresh="getSideControlMenu('clmHistory').show"
      ></Claim-History>
    </v-dialog>
    <v-dialog v-model="loadingFlag" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Loading...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <confirm-auth v-model="promptAuth" @ok="doAuthPend" @cancel="validDelPassword" yes-label="Yes" no-label="No">{{ authTxt }}</confirm-auth>
    <v-dialog v-model="promptCaptureAuth" width="500px" persistent>
      <CaptureAuth @close="doCloseEnterPassword" @returnClmManagement="returnClmManagement" @updateRecord="updateAfterAuth" @cancel="doCloseEnterPassword" :clmNo="this.commonInfo.clmNo" :clmStat="this.commonInfo.clmStat" :screen="this.reserveOrPayment"  :del="false"></CaptureAuth>
    </v-dialog>
    <v-dialog v-model="promptCaptureAuthDel" width="500px" persistent>
      <CaptureAuth @close="doCloseEnterPassword" @updateRecord="doDelPend" @cancel="doCloseEnterPassword" :clmNo="this.commonInfo.clmNo" :clmStat="this.commonInfo.clmStat" :screen="this.reserveOrPayment" :del="true"></CaptureAuth>
    </v-dialog>
    <confirm-auth v-model="promptAuthApproveTxt" yes-label="Cancel" :info="true">{{ authApproveTxt }}</confirm-auth>
  </page>
</template>

<script>
import Comments from '@/components/core/claimManagement/Comments'
import ClaimLifeCycle from '@/components/core/claimManagement/register/ClaimLifeCycle'
import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'
import ClaimAccount from '@/components/core/claimManagement/sideFunction/ClaimAccount'
import ClaimAttachFile from '@/components/core/claimManagement/sideFunction/ClaimAttachFile'
import ClaimMotorDriver from '@/components/core/claimManagement/sideFunction/ClaimMotorDriver'
import ClaimText from '@/components/core/claimManagement/sideFunction/ClaimText'
import ClaimReinsurance from '@/components/core/claimManagement/sideFunction/ClaimReinsurance'
import ClaimStatistics from '@/components/core/claimManagement/sideFunction/ClaimStatistics'
import ClaimHelperMenu from '@/components/core/claimManagement/helper/ClaimHelperMenu'
import SaveErrorDialog from '@/components/core/claimManagement/SaveErrorDialog'
import ClaimStatus from '@/components/core/claimManagement/sideFunction/ClaimStatus'
import ClaimReserve from '@/components/core/claimManagement/sideFunction/ClaimReserve'
import ClaimPayment from '@/components/core/claimManagement/sideFunction/ClaimPayment'
import ClaimRIRecovery from '@/components/core/claimManagement/sideFunction/ClaimRIRecovery'
import ClaimHistory from '@/components/core/claimManagement/sideFunction/ClaimHistory'
import ClaimByLossDate from '@/components/core/claimManagement/sideFunction/ClaimByLossDate'
import XOLRecovery from '@/components/core/claimManagement/sideFunction/XOLRecovery'
import XOLWorksheet from '@/components/core/claimManagement/sideFunction/XOLWorksheet'
import ClaimStatusDialog from '@/components/core/claimManagement/ClaimStatusDialog'
import ClmDocument from '@/components/core/claimManagement/sideFunction/clmDocument/ClmDoc'
import routeMixin from '@/mixins/route'
import { mapGetters } from 'vuex'
import CaptureAuth from '@/components/core/claimManagement/CaptureAuth'
import ConfirmAuth from '@/components/core/claimManagement/ConfirmAuth'
import { removeFormatNumber } from '@/utils/number'
import { ClaimCommonMixin } from '@/mixins/claim/ClaimCommonMixin'
import { CLAIMS_LIFECYCLE } from '@/store/types'

export default {
  data() {
    return {
      tour: undefined,
      lifeCycle: false,
      statusChange: false,
      saveError: false,
      query: false,
      breadcrumb: [],
      selectedKey: undefined,
      control: [
        { name: 'clmMtrDrvr', type: 'dialog', show: false },
        { name: 'clmAcct', type: 'dialog', show: false },
        { name: 'clmstatus', type: 'dialog', show: false },
        { name: 'statistics', type: 'dialog', show: false },
        { name: 'text', type: 'dialog', show: false },
        { name: 'reinsurance', type: 'dialog', show: false },
        { name: 'xolrcvy', type: 'dialog', show: false },
        { name: 'xolWrksht', type: 'dialog', show: false },
        { name: 'clmattachfile', type: 'dialog', show: false },
        { name: 'clmres', type: 'dialog', show: false },
        { name: 'clmpayt', type: 'dialog', show: false },
        { name: 'clmrircvy', type: 'dialog', show: false },
        { name: 'clmByLossDate', type: 'dialog', show: false },
        { name: 'clmDoc', type: 'dialog', show: false },
        { name: 'clmHistory', type: 'dialog', show: false },
        { name: 'polMaster', type: 'router' }
      ],
      loadingFlag: false,
      promptAuth: false,
      promptCaptureAuth: false,
      promptCaptureAuthDel: false,
      authTxt: '',
      mainForm: {
        clmNo: null
      },
      exceedLimit: '',
      reserveOrPayment: false,
      authApproveTxt: 'User Not Authorised to Approve Transaction',
      promptAuthApproveTxt: false
    }
  },
  watch: {
    saveErrorMsg: {
      handler: function (value) {
        if ((value.messages && value.messages.length > 0) || (value.fieldMessages && value.fieldMessages.length > 0)) {
          this.saveError = true
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(['checkAccess']),
    claimDetail() {
      return this.$store.state.claims.claimDetail
    },
    commonInfo() {
      return this.claimDetail.commonInfo
    },
    claimRegister() {
      return this.$store.state.claims.claimRegister
    },
    saveErrorMsg() {
      return this.$store.state.claims.claimDetail.saveError
    },
    renderComments() {
      return this.$route.name !== 'claimRegister' && this.$store.state.claims.claimDetail.claimLifeCycle > 1
    },
    sideFunction() {
      let result = [
        { text: 'Accounts Master', icon: 'mdi-library-books', iconColor: 'primary', params: { key: 'clmAcct' } },
        { text: 'Attachments', icon: 'mdi-attachment', iconColor: 'primary', params: { key: 'clmattachfile' } },
        { text: 'Claims Documents', icon: 'mdi-file-document', iconColor: 'primary', params: { key: 'clmDoc' } },
        { text: 'Claims of Similar Date of Loss', icon: 'mdi-compare', iconColor: 'primary', params: { key: 'clmByLossDate' } }
        // { text: 'Claims History', icon: 'mdi-history', iconColor: 'primary', params: { key: 'clmHistory' } }
      ]
      if (this.$store.state.claims.claimDetail.commonInfo.appID === 'MO') {
        result.push({ text: 'Driver Details', icon: 'mdi-account-card-details', iconColor: 'primary', params: { key: 'clmMtrDrvr' } })
      }
      result.push({ text: 'Payments', icon: 'mdi-cash-multiple', iconColor: 'primary', params: { key: 'clmpayt' } })
      if (this.$route.name === 'claimHeader') {
        result.push({ text: 'Policy Master', icon: 'mdi-library-books', iconColor: 'primary', params: { key: 'polMaster' } })
      }
      result.push({ text: 'Reinsurance', icon: 'mdi-content-duplicate', iconColor: 'primary', params: { key: 'reinsurance' } })
      result.push({ text: 'Reserves', icon: 'mdi-view-list', iconColor: 'primary', params: { key: 'clmres' } })
      result.push({ text: 'RI Recoveries', icon: 'mdi-redo-variant', iconColor: 'primary', params: { key: 'clmrircvy' } })

      if (this.$route.name === 'claimHeader') {
        result.push({ text: 'Statistics', icon: 'mdi-chart-areaspline', iconColor: 'primary', params: { key: 'statistics' } })
      }
      result.push({ text: 'Status', icon: 'mdi-history', iconColor: 'primary', params: { key: 'clmstatus' } })
      result.push({ text: 'Text', icon: 'mdi-note-text', iconColor: 'primary', params: { key: 'text' } })
      result.push({ text: 'XOL Recoveries', icon: 'mdi-redo-variant', iconColor: 'primary', params: { key: 'xolrcvy' } })
      if (this.$store.state.claims.claimDetail.commonInfo.xolRcvys.length > 0) {
        result.push({ text: 'XOL Worksheets', icon: 'mdi-file-document-box', iconColor: 'primary', params: { key: 'xolWrksht' } })
      }
      return result
    }
  },
  methods: {
    async sideMenuClick(data) {
      if (data.key === 'clmstatus') {
        await this.getPendClmAll()
      }
      var foundIndex = this.control.findIndex((x) => x.name === data.key)
      let type = this.control[foundIndex].type
      if (type === 'dialog') {
        this.control[foundIndex].show = true
      } else if (type === 'router') {
        this.redirect(this.control[foundIndex].name)
      }
    },
    async doCloseEnterPassword() {
      this.promptCaptureAuth = false
      this.promptCaptureAuthDel = false
      this.promptAuth = true
    },
    // polMaster
    async redirect(key) {
      this.loadingFlag = true
      if (key === 'polMaster') {
        let data = {
          item: {
            polNo: this.commonInfo.polNo,
            renCnt: this.commonInfo.renCnt,
            endtCnt: this.commonInfo.endtCnt
          }
        }
        this.$store.dispatch('dispatchSave', { key: 'ReviewClaim', data: { clmNo: this.commonInfo.clmNo } })
        await this.$store.dispatch('reviewPolicy', data).then(() => {
          this.$router.push({ name: 'queryPolicy' })
        })
      }
      this.$root.$emit('leaveClaim')
      this.loadingFlag = false
    },
    getSideControlMenu(key) {
      for (let param of this.control) {
        if (param.name === key) {
          return param
        }
      }
      return {}
    },
    async doInit() {
      await this.$store.dispatch('claimsRegisterInit')
      await this.$store.dispatch('underwritingInit')
    },
    toggleQuery(isQueryMode = false) {
      this.query = isQueryMode
    },
    editStatusChange() {
      this.lifeCycle = false
      this.statusChange = true
    },
    async updateAfterAuth() {
      this.promptCaptureAuth = false
      this.promptCaptureAuthDel = false
      let reserveAmt = 0
      let reserveAmtLoc = 0
      this.commonInfo.clmReses.forEach(item => {
        if (item.status === 'P') {
          item.status = ''
          reserveAmt = item.reserve
          reserveAmtLoc = item.reserveLoc
        }
      })
      let paytAmt = 0
      let paytAmtLoc = 0
      let clmResCat = null
      this.commonInfo.clmPayts.forEach(item => {
        if (item.status === 'P') {
          item.status = ''
          paytAmt = item.paytAmt
          paytAmtLoc = item.paytAmtRes
          clmResCat = item.clmResCat
        }
      })
      this.commonInfo.clmAccumRes.forEach(item => {
        if (clmResCat != null && clmResCat === item.clmResCat) {
          item.planned = parseFloat(removeFormatNumber(item.planned)) + parseFloat(removeFormatNumber(paytAmt))
          item.plannedRes = parseFloat(removeFormatNumber(item.plannedRes)) + parseFloat(removeFormatNumber(paytAmt))
          item.plannedLoc = parseFloat(removeFormatNumber(item.plannedLoc)) + parseFloat(removeFormatNumber(paytAmtLoc))
          item.totRes = parseFloat(removeFormatNumber(item.totRes)) - parseFloat(removeFormatNumber(paytAmt))
          item.totResLoc = parseFloat(removeFormatNumber(item.totResLoc)) - parseFloat(removeFormatNumber(paytAmtLoc))
          item.clmResOS = parseFloat(removeFormatNumber(item.clmResOS)) - parseFloat(removeFormatNumber(paytAmt))
          item.clmResOSLoc = parseFloat(removeFormatNumber(item.clmResOSLoc)) - parseFloat(removeFormatNumber(paytAmtLoc))
        }
      })
      this.commonInfo.totPlannedRes = this.commonInfo.totPlannedRes + parseFloat(removeFormatNumber(paytAmt))
      this.commonInfo.totPlanned = this.commonInfo.totPlanned + parseFloat(removeFormatNumber(paytAmt))
      this.commonInfo.totPlannedLoc = this.commonInfo.totPlannedLoc + parseFloat(removeFormatNumber(paytAmtLoc))
      this.commonInfo.totAccumRes = this.commonInfo.totAccumRes - parseFloat(removeFormatNumber(paytAmt))
      this.commonInfo.totAccumResLoc = this.commonInfo.totAccumResLoc - parseFloat(removeFormatNumber(paytAmtLoc))
      let itemTemp
      let exist = false
      this.commonInfo.clmAccumRes.forEach(item => {
        if (item.status === 'P') {
          itemTemp = item
        }
      })
      if (itemTemp !== undefined) {
        this.commonInfo.clmAccumRes.forEach(item => {
          if (item.clmResCat === itemTemp.clmResCat && item.status !== 'P') {
            exist = true
          }
        })
        if (exist === false) {
          this.commonInfo.clmAccumRes.forEach(item => {
            if (item.clmResCat === itemTemp.clmResCat && item.status === 'P') {
              item.status = ''
            }
          })
        } else {
          this.commonInfo.clmAccumRes = this.commonInfo.clmAccumRes.filter(item => {
            return !(item.clmResCat === itemTemp.clmResCat && item.status === 'P')
          })
          this.commonInfo.clmAccumRes.filter(item => {
            if (item.clmResCat === itemTemp.clmResCat) {
              item.status = ''
              item.totRes = parseFloat(removeFormatNumber(item.totRes)) + parseFloat(removeFormatNumber(itemTemp.totRes))
              item.totResLoc = parseFloat(removeFormatNumber(item.totResLoc)) + parseFloat(removeFormatNumber(itemTemp.totResLoc))
              item.clmResOS = parseFloat(removeFormatNumber(item.clmResOS)) + parseFloat(removeFormatNumber(itemTemp.clmResOS))
              item.clmResOSLoc = parseFloat(removeFormatNumber(item.clmResOSLoc)) + parseFloat(removeFormatNumber(itemTemp.clmResOSLoc))
            }
          })
        }
        this.commonInfo.totAccumRes = this.commonInfo.totAccumRes + parseFloat(removeFormatNumber(reserveAmt))
        this.commonInfo.totAccumResLoc = this.commonInfo.totAccumResLoc + parseFloat(removeFormatNumber(reserveAmtLoc))
      }
      if (this.claimDetail.claimLifeCycle === 5) {
        this.$store.commit(CLAIMS_LIFECYCLE, 5)
        this.doInit()
        this.activeHeaders = this.reserveHeaders[this.displayCurr]
      }
    },
    returnClmManagement() {
      this.$root.$emit('leaveClaim')
      this.$router.push({ name: 'mngClaim' })
    },
    validDelPassword() {
      this.promptCaptureAuthDel = true
    }
  },
  mounted() {
    this.doInit()
  },
  components: {
    ClaimLifeCycle,
    SaveErrorDialog,
    Comments,
    ClaimHelperMenu,
    ClaimStatusDialog,
    SideFunctionMenu,
    ClaimAccount,
    ClaimMotorDriver,
    ClaimAttachFile,
    ClaimText,
    ClaimReinsurance,
    ClaimStatistics,
    ClaimStatus,
    ClaimReserve,
    ClaimPayment,
    ClaimRIRecovery,
    ClaimByLossDate,
    XOLRecovery,
    XOLWorksheet,
    ClaimHistory,
    ClmDocument,
    CaptureAuth,
    ConfirmAuth
  },
  mixins: [ClaimCommonMixin, routeMixin]
}
</script>

<style lang="scss">
// Side info for all quotation
.quoteSideInfo {
  // Overwrite toolbar margin on side info
  .toolbar__content > *:not(.btn):not(.menu):last-child,
  .toolbar__extension > *:not(.btn):not(.menu):last-child {
    margin-right: 0px;
  }
}
// Internal quotation lifecycle for all quotation
.quoteLifeCycle {
  &.v-stepper {
    background: none !important;
    box-shadow: none !important;
  }
}
</style>
